module.exports = __webpack_public_path__ + "img/valueOperatingAssets.8b860973.png";